import React, { Component } from "react";

const params = new URLSearchParams(window.location.search);
const token_id = params.get("token_id");
const status = params.get("status") || "success";

const FACEBOOK_OAUTH_CHANNEL_NAME = "robomd_instagram_facebook_oauth";
const FACEBOOK_OAUTH_STORAGE_KEY = "robomd_instagram_facebook_oauth_event";

const createBridgeEventId = () => {
  try {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
  } catch (e) {
    // fallback 사용
  }

  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
};

const publishBridgeMessage = (payload) => {
  if (typeof BroadcastChannel !== "undefined") {
    try {
      const channel = new BroadcastChannel(FACEBOOK_OAUTH_CHANNEL_NAME);
      channel.postMessage(payload);
      setTimeout(() => channel.close(), 0);
    } catch (e) {
      console.warn("Facebook OAuth BroadcastChannel 전송 실패:", e);
    }
  }

  try {
    localStorage.setItem(FACEBOOK_OAUTH_STORAGE_KEY, JSON.stringify(payload));
    localStorage.removeItem(FACEBOOK_OAUTH_STORAGE_KEY);
  } catch (e) {
    console.warn("Facebook OAuth storage 이벤트 전송 실패:", e);
  }
};

class callbackForRefleshParent extends Component {
  state = {
    closeBlocked: false,
  };

  componentDidMount() {
    this.bridgeEventId = createBridgeEventId();

    if (typeof BroadcastChannel !== "undefined") {
      try {
        this.facebookOAuthChannel = new BroadcastChannel(FACEBOOK_OAUTH_CHANNEL_NAME);
        this.facebookOAuthChannel.onmessage = (e) => {
          this.handleBridgeMessage(e.data);
        };
      } catch (e) {
        console.warn("Facebook OAuth BroadcastChannel 연결 실패:", e);
      }
    }

    this.storageHandler = (e) => {
      if (e.key !== FACEBOOK_OAUTH_STORAGE_KEY || !e.newValue) return;

      try {
        this.handleBridgeMessage(JSON.parse(e.newValue));
      } catch (error) {
        console.warn("Facebook OAuth storage 메시지 파싱 실패:", error);
      }
    };

    window.addEventListener("storage", this.storageHandler);

    const payload = {
      type: "refreshInstagramAccount",
      result: status,
      token_id: token_id,
      bridge_event_id: this.bridgeEventId,
      bridge_sent_at: Date.now(),
    };

    // 부모 탭은 이미 열려 있으므로 즉시 전달한다.
    publishBridgeMessage(payload);

    // 응답이 오지 않아도 기존처럼 일정 시간 후 닫기를 시도한다.
    this.fallbackTimer = setTimeout(() => {
      this.tryClose();
    }, 4000);
  }

  componentWillUnmount() {
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
    }
    if (this.closeCheckTimer) {
      clearTimeout(this.closeCheckTimer);
    }
    if (this.storageHandler) {
      window.removeEventListener("storage", this.storageHandler);
    }
    if (this.facebookOAuthChannel) {
      this.facebookOAuthChannel.close();
    }
  }

  handleBridgeMessage = (data) => {
    if (!data || data.type !== "refreshInstagramAccountDone") return;
    if (data.bridge_event_id && data.bridge_event_id !== this.bridgeEventId) return;

    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
      this.fallbackTimer = null;
    }

    this.tryClose();
  };

  tryClose = () => {
    window.close();

    // 모바일 Chrome 등에서 자동 닫기가 차단된 경우 안내 문구를 표시한다.
    this.closeCheckTimer = setTimeout(() => {
      if (!window.closed) {
        this.setState({ closeBlocked: true });
      }
    }, 500);
  };

  render() {
    if (!this.state.closeBlocked) {
      return <div></div>;
    }

    return (
      <div style={{ padding: "80px 24px 24px 24px", textAlign: "center", lineHeight: "1.6" }}>
        계정 연동을 완료 하시려면,<br />
        원래 RoboMD 탭으로 돌아가 주세요.
      </div>
    );
  }
}

export default callbackForRefleshParent;
